<form [formGroup]="registrationForm">
    <div class="card p-fluid">
      <header class="black-center mb-5 w-full">
        <h5 class="mt-3 white-col"><strong>CHANGE DETAIL</strong></h5>
      </header>
      <div class="p-formgrid grid">
        <div class="field col feild-bg ">
          <label for="Company_Title"><strong>Company Title<span class="required-asterisk">*</span></strong></label>
          <p-dropdown [options]="Company_Title" id="Company_Title" [readonly]="isNotEditable" formControlName="company_title"
            placeholder="Select an Option" [style]='{"border":"2px solid gray"}'></p-dropdown>
        </div>
        <div class="field col feild-bg">
          <label for="business_name" class="label-spacing"><strong>Vendor Name</strong><span
              class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
          <input id="business_name" type="text" class="highlight" [readonly]="isNotEditable" pInputText formControlName="business_name" />
        </div>
        <div class="field col feild-bg" >
          <label for="short_name"><strong>Vendor Code</strong><span
              class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
          <input id="short_name" type="text" class="highlight" pInputText formControlName="vendor_code" [readonly]="isNotEditable"/>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col">
          <label for="short_name"><strong>Short Name</strong><span
              class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
          <input id="short_name" type="text" pInputText formControlName="short_name" />
        </div>

        <div class="field col">
          <label for="country"><strong>Plant<span
            class="required-asterisk">*</span></strong></label>
          <!-- <input
                id="country"
                type="text"
                pInputText
                formControlName="country"
              /> -->
          <p-dropdown [options]="plantList" id="plant" formControlName="plant" optionValue="plant__code" placeholder="Select an Option"
            optionLabel="name1"></p-dropdown>
        </div>
      </div>
      <!-- <header class="orange-center">
          <p><strong>PRIMARY ADDRESS</strong></p>
        </header> -->
      <div formGroupName="primary_address">
        <div class="p-formgrid grid">
          <div class="field col feild-bg">
            <label for="address_title"><strong>Address Title</strong><span
                class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
            <input id="address_title" type="text" pInputText formControlName="address_title" />
          </div>
          <!-- <div class="field col feild-bg">
            <label><strong>Address Type<span class="required-asterisk">*</span></strong></label>
            <p-dropdown [options]="options1" formControlName="address_type" placeholder="Select an Option"></p-dropdown>
          </div> -->
          <div class="field col feild-bg">
            <label for="address_line_1"><strong>Street / House Number</strong><span
                class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
            <input id="address_line_1" type="text" pInputText formControlName="address_line_1" />
          </div>
        </div>
        <div class="p-formgrid grid">
          <div class="field col">
            <label for="address_line_2"><strong>District</strong><span class="required-asterisk">*</span></label>
            <input id="address_line_2" type="text" pInputText formControlName="address_line_2" />
          </div>
          <div class="field col">
            <label for="country"><strong>Country</strong><span class="required-asterisk">*</span></label>
            <p-dropdown [options]="countries_List" id="country" formControlName="country" placeholder="Select an Option"
            [virtualScroll]="true" [virtualScrollItemSize]="20" [filter]="true" [showClear]="true" optionLabel="label"  filterBy="label"
            optionValue="value"
              (onChange)="onStateChange($event.value)"></p-dropdown>
          </div>
        </div>
        <div class="p-formgrid grid">
          <div class="field col feild-bg" *ngIf="hideCity">
            <label for="city"><strong>City</strong><span class="required-asterisk">*</span></label>
            <p-dropdown formControlName="city" [virtualScroll]="true" [virtualScrollItemSize]="20" [filter]="true" [showClear]="true" filterBy="name" (onChange)="onCityChange($event.value)" [options]="cityAndStateList" optionLabel="city" placeholder="Select a City" />
          </div>
          <div class="field col feild-bg" *ngIf="!hideCity">
            <label for="city"><strong>City</strong><span class="required-asterisk">*</span></label>
            <input id="city" type="text" pInputText formControlName="city" />
          </div>
          <!-- <div class="field col feild-bg" *ngIf="hideState">
            <label for="state"><strong>State/Province</strong><span class="required-asterisk">*</span></label>
            <p-dropdown formControlName="state" [options]="state" optionLabel="label" optionValue="value" placeholder="Select a State" />
          </div> -->
          <div class="field col feild-bg">
            <label for="state"><strong>State/Province</strong><span class="required-asterisk">*</span></label>
            <input id="state" type="text" pInputText formControlName="state" />
          </div>
        </div>

        <div class="p-formgrid grid">

          <div class="field col">
            <label for="postal_code"><strong>Postal Code</strong><span class="required-asterisk">*</span></label>
            <input id="postal_code" type="text" (keydown)="validatePostalCode($event)" (keydown)="validateNumber($event)"
              pInputText formControlName="postal_code" />
          </div>
          <div class="field col">
            <label for="fax"><strong>Fax</strong></label>
            <input id="fax" type="text" pInputText formControlName="fax" />
          </div>
        </div>
        <!-- <div class="p-formgrid grid">

          <div class="field col"></div> -->
          <!-- <div class="field col"></div> -->
        <!-- </div> -->
      </div>
      <div class="p-formgrid grid">
        <div class="field col-6">
          <label for="MCA"><strong>Ministry Of Corporate Affairs(MCA)</strong></label>
          <p-dropdown [options]="MCA" id="MCA" formControlName="ministry_of_corporate_affairsmca"
            placeholder="Select an Option" (onChange)="mcaNoOnChange($event.value)"></p-dropdown>
        </div>
        <div class="field col-2" *ngIf="ismca()">
          <label for="mca_number"><strong>MCA Number<span class="required-asterisk">*</span></strong></label>
          <input id="mca_number" type="text" pInputText formControlName="mca_number" (blur)="mcaNoOnBlur($event)" />
        </div>
        <div class="field col-2" *ngIf="ismca()">
          <label htmlFor="MCAFILE"><strong>MCA FILE</strong></label>
          <p-fileUpload mode="basic" name="uploadGstFile[]" accept="image/*,.pdf,.xls,.xlsx" [maxFileSize]="25000000"
            (onSelect)="mcaUpload($event)" chooseLabel="Upload File" *ngIf="!mcaDocument"
            pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
            tooltipPosition="right"></p-fileUpload>
          <div *ngIf="mcaDocument">
            <span>{{ mcaDocument.name }}</span>
            <button type="button" pButton icon="pi pi-check" class="p-fileupload-close p-button-rounded p-button-success"
              (click)="cancelMcaDocumentUpload()"></button>
          </div>
        </div>
        <div class="field col-2" *ngIf="!ismca()"></div>
        <div class="field col-2">
          <button pButton class="btn btn-primary" *ngIf="mca_documentUrl" style="max-width: min-content;margin-top:30px"
            (click)="downloadFile(mca_documentUrl, 'mca_document')">
            <i class="pi pi-download"></i>
          </button>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg">
          <label for="GST Registered"><strong>GST Registered</strong><span class="required-asterisk">*</span></label>
          <p-dropdown [options]="GST_Registered" id="GST_Registered" formControlName="gst_registered"
            placeholder="Select one from below" [readonly]="isGst" (onChange)="updateGstnValidators($event.value)"></p-dropdown>
        </div>
        <div class="field col feild-bg">
          <label for="GST Registered"><strong>Select Industry Type</strong><span
              class="required-asterisk">*</span></label>
          <p-dropdown [options]="SelectIndustryType" id="SelectIndustryType" formControlName="select_industry_type"
            placeholder="Select one from below" optionLabel="label" optionValue="value" (onChange)="SelectIndustryType1($event.value)"></p-dropdown>
        </div>
      </div>
      <div formGroupName="primary_address">
        <div formGroupName="tax_details">
          <div class="p-formgrid grid" *ngIf="isGSTRegistered()">
            <div class="field col-6">
              <label htmlFor="gstn"><strong>GST Number<span class="required-asterisk">*</span></strong></label>
              <input id="gstn" type="text" [readonly]="isGst" class="highlight" pInputText formControlName="gstn" (change)="onGstnBlur($event)"
                (keydown)="onGstnInput($event)" [class.error]="
                  gstnNumber &&
                  gstnNumber.invalid &&
                  (gstnNumber.dirty || gstnNumber.touched)
                " />
              <div *ngIf="
                  gstnNumber &&
                  gstnNumber.invalid &&
                  (gstnNumber.dirty || gstnNumber.touched)
                ">
                <div *ngIf="gstnNumber.errors && gstnNumber.errors['required']" style="color: red">
                  GST Number is required
                </div>
                <div *ngIf="gstnNumber.errors && gstnNumber.errors['invalidGstn']" style="color: red">
                  Invalid GST Number
                </div>
              </div>
            </div>
            <div class="field col-3">
              <label htmlFor="email2"><strong>GST FILE</strong></label>
              <p-fileUpload mode="basic" name="uploadGstFile[]" accept="image/*,.pdf,.xls,.xlsx" [maxFileSize]="25000000"
                (onSelect)="onUploadFile($event, 'upload_gst')" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" *ngIf="!uploadGstFile"></p-fileUpload>
              <div *ngIf="uploadGstFile">
                <span>{{ uploadGstFile.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelUpload('upload_gst')"></button>
              </div>
              <div style="color: red"
                *ngIf="registrationForm.get('primary_address.tax_details.gstFile')?.errors?.['required'] && registrationForm.get('primary_address.tax_details.gstFile')?.touched">
                GST File is required
              </div>
            </div>
            <div class="field col-3">
              <button pButton class="btn btn-primary" *ngIf="upload_gstUrl"
                style="max-width: min-content; margin-top: 30px;" (click)="downloadFile(upload_gstUrl, 'upload_gst')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
          <div class="p-formgrid grid">
            <div class="field col">
              <label for="vat_registration_number"><strong>VAT Registration Number</strong></label>
              <input id="vat_registration_number" type="text" pInputText formControlName="vat_registration_number" />
            </div>
            <div class="field col">
              <label for="service_tax_registration_number"><strong>Service Tax Registration Number</strong></label>
              <input id="service_tax_registration_number" type="text" pInputText
                formControlName="service_tax_registration_number" />
            </div>
          </div>
          <!-- <div class="p-formgrid grid">
            <div class="field col"></div>
          </div> -->
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg">
          <label for="GST Registered"><strong>Vendor Type</strong></label>
          <p-dropdown [options]="VendorType" id="VendorType" formControlName="vendor_type"
            placeholder="Select one from below"></p-dropdown>
        </div>
        <div class="field col feild-bg" style="width: fit-content">
          <label htmlFor="email2">
            <strong>Profile Photo</strong>
          </label>
          <div class="p-formgrid grid">
            <div class="field col">
              <p-fileUpload mode="basic" name="demo[]" accept="image/*,application/pdf" [maxFileSize]="25000000"
                (onSelect)="onVendorImageUpload($event)" chooseLabel="Upload File" *ngIf="!vendorImageFile"
                pTooltip=".pdf, .jpg, .png, .jpeg Extenstion Accepted (Max file size 25MB)" tooltipPosition="right">
              </p-fileUpload>
              <div *ngIf="vendorImageFile">
                <span>{{ vendorImageFile.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelVendorImageUpload()"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content" *ngIf="propertiery_imgUrl"
                (click)="downloadFile(propertiery_imgUrl, 'propertiery_img')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <header class="orange-center">
        <p><strong>VENDOR CLASSIFICATION</strong></p>
      </header>
      <div class="p-formgrid grid mt-3">
        <div class="field col">
          <label for="vendor_classification"><strong>Vendor Classification<span class="required-asterisk">*</span></strong></label>
          <p-dropdown [options]="options" id="vendor_classification" formControlName="vendor_classification"
            placeholder="Select an Option"></p-dropdown>
        </div>
      </div>
      <header class="orange-center">
        <p><strong>TURN OVER DETAILS</strong></p>
      </header>
      <div class="p-formgrid grid mt-3">
        <div class="field col feild-bg">
          <label for="previous_year"><strong>Financial Year {{ financialPreviousYear }} (In
              Lakhs)</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="previous_year" type="number" (keydown)="validateNumber($event)" pInputText
            formControlName="previous_year" />
        </div>
        <div class="field col feild-bg">
          <label for="one_year_before_previous_year" class="label-spacing"><strong>Financial Year {{
              financialOneYearBeforePreviousYear }} (In
              Lakh)</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="one_year_before_previous_year" type="number" (keydown)="validateNumber($event)" pInputText
            formControlName="one_year_before_previous_year" />
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col">
          <label for="two_years_before_previous_year"><strong>Financial Year {{ financialtwoYearsBeforePreviousYear }} (In
              Lakh)&nbsp;&nbsp;&nbsp;</strong></label>
          <input id="two_years_before_previous_year" type="number" (keydown)="validateNumber($event)" pInputText
            formControlName="two_years_before_previous_year" />
        </div>
        <div class="field col"></div>
      </div>

      <form [formGroup]="multipleBankDetailForm">
        <div formArrayName="multipleBank">
          <div class="border-1 border-round surface-border">
            <header class="orange-center">
              <p><strong>BANK DETAILS</strong></p>
            </header>

            <div class="overflow-x-auto" style="min-width: 100%">
              <div *ngFor="let bank of multipleBank.controls; let i = index" [formGroupName]="i">
                <div class="flex flex-nowrap p-3 gap-3" style="min-width: max-content">
                  <div class="field mt-5" style="min-width: 50px" *ngIf="i == 0">
                    <button pButton
                            type="button"
                            icon="pi pi-plus"
                            class="p-button-sm p-button-primary"
                            [style]='{"width":"50px"}'
                            (click)="addMultipleBankDetail()">
                    </button>
                  </div>
                  <div class="field" style="min-width: 50px"  *ngIf="i != 0"></div>
                  <div class="field mt-5" style="min-width: 50px">
                    <button pButton
                            type="button"
                            icon="fas fa-trash"
                            class="p-button-sm p-button-danger"
                            [style]='{"width":"50px"}'
                            (click)="removeBankDetail(i)">
                    </button>
                  </div>
                  <div class="field mt-2">
                    <label [for]="'country'+i" class="font-bold block">Country</label>
                    <input [id]="'country'+i" type="text" pInputText [disabled]="true" value="IN" [ngStyle]="{ 'width': '50px' }"/>
                  </div>

                  <div class="field" style="max-width: 150px">
                    <label [for]="'ifsc_code'+i"><strong>IFSC Code</strong><span class="required-asterisk">*</span></label>
                    <input [id]="'ifsc_code'+i" type="text" pInputText formControlName="ifsc_code"
                      (keydown)="validateIFSCCode($event)" />
                  </div>

                  <div class="field mt-5" style="min-width: 50px">
                    <button type="button" pButton icon="pi pi-search"
                      (click)="searchIFSCCode(bank.get('ifsc_code')?.value,i)"></button>
                  </div>

                  <div class="field" style="max-width: 160px">
                    <label [for]="'account_no'+i"><strong>Account No</strong><span class="required-asterisk">*</span></label>
                    <input [id]="'account_no'+i" type="text" (keydown)="validateNumber($event)" pInputText
                      formControlName="account_no" />
                    <div *ngIf="
                      bank.get('account_no')?.invalid &&
                      (bank.get('account_no')?.dirty ||
                      bank.get('account_no')?.touched)
                    ">
                      <div *ngIf="bank.get('account_no')?.errors?.['required']" style="color: red">
                        Account No is required.
                      </div>
                      <div *ngIf="bank.get('account_no')?.errors?.['specialCharacters']" style="color: red">
                        Account No cannot contain special characters.
                      </div>
                    </div>
                  </div>

                  <div class="field" style="min-width: 250px">
                    <label [for]="'account_holder__registered_name'+i"><strong>Account Holder/Name</strong><span
                      class="required-asterisk">*</span></label>
                    <input [id]="'account_holder__registered_name'+i" type="text" pInputText
                      formControlName="account_holder__registered_name" />
                  </div>

                  <div class="field" style="width: 250px">
                    <label [for]="'plant_code'+i" class="font-bold block">Plant Code<span
                      class="required-asterisk">*</span></label>
                    <p-dropdown formControlName="plant_code" appendTo="body" [options]="bankPlantNameAndCode" optionLabel="label" optionValue="value"
                      placeholder="Select Plant Code" (onChange)="onPlantCodeChange($event, i)"/>
                      <div *ngIf="bank.get('plant_code')?.errors?.['duplicatePlant']" style="color: red">
                        This plant code is already selected for another bank detail.
                      </div>
                  </div>

                  <div class="field" style="min-width: 200px">
                    <label [for]="'bank_name'+i"><strong>Bank Name</strong><span class="required-asterisk">*</span></label>
                    <input [id]="'bank_name'+i" type="text" pInputText formControlName="bank_name" />
                  </div>

                  <div class="field" style="min-width: 200px">
                    <label [for]="'branch_name'+i"><strong>Branch Name</strong><span class="required-asterisk">*</span></label>
                    <input [id]="'branch_name'+i" type="text" pInputText formControlName="branch_name" />
                  </div>

                  <div class="field" style="min-width: 200px">
                    <label [htmlFor]="'Cancel-cheq'+i">
                      <strong>Upload Bank Document</strong>
                    </label>
                    <p-fileUpload mode="basic" name="CancelledChequeFile[]" accept="image/*,.pdf,.xls,.xlsx"
                      [maxFileSize]="25000000" (onSelect)="onUploadFileForCancelledCheque($event, 'cancelled_cheque',i)"
                      chooseLabel="Upload File"
                      pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                      tooltipPosition="right" *ngIf="!bank.get('cancelled_cheque')?.value">
                    </p-fileUpload>
                    <div *ngIf="bank.get('cancelled_cheque')?.value">
                      <span>{{ bank.get('cancelled_cheque')?.value }}</span>
                      <button type="button" pButton icon="pi pi-check"
                        class="p-fileupload-close p-button-rounded p-button-success"
                        (click)="cancelUploadForCancelledCheque(i,bank.get('cancelled_cheque')?.value)"></button>
                    </div>
                  </div>

                  <div class="field mt-5" style="min-width: 150px" *ngIf="patchBankUploaded[i]?.cancelled_cheque">
                    <button pButton class="btn btn-primary" style="max-width: min-content"
                      (click)="downloadFileForBanks(i, 'cancelled_cheque_' + i)">
                      <i class="pi pi-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- <form [formGroup]="multipleBankDetailForm">
          <div formArrayName="multipleBank">
            <div *ngFor="let bank of multipleBank.controls; let i = index" [formGroupName]="i">

              <header class="orange-center">
                <p><strong>BANK DETAILS {{i + 1}}</strong></p>
              </header>

            <div class="p-formgrid grid mt-5">
              <div class="field col feild-bg">
                <label for="account_holder__registered_name"><strong>Account Holder/Name</strong><span
                    class="required-asterisk">*</span></label>
                <input id="account_holder__registered_name" type="text" pInputText
                  formControlName="account_holder__registered_name" />
              </div> -->
              <!-- <div class="field col feild-bg">
                <label for="account_no"><strong>Account No</strong><span class="required-asterisk">*</span></label>
                <input id="account_no" type="text" (keydown)="validateNumber($event)" pInputText
                  formControlName="account_no" />
              </div> -->
              <!-- <div class="field col feild-bg">
                <label for="account_no"><strong>Account No</strong><span class="required-asterisk">*</span></label>
                <input id="account_no" type="text" (keydown)="validateNumber($event)" pInputText
                  formControlName="account_no" />
                <div *ngIf="
                bank.get('account_no')?.invalid &&
                    (bank.get('account_no')?.dirty ||
                    bank.get('account_no')?.touched)
                  ">
                  <div *ngIf="bank.get('account_no')?.errors?.['required']" style="color: red">
                    Account No is required.
                  </div>
                  <div *ngIf="bank.get('account_no')?.errors?.['specialCharacters']" style="color: red">
                    Account No cannot contain special characters.
                  </div>
                </div>
              </div>
            </div>
            <div class="p-formgrid grid">
              <div class="field col">
                <label for="ifsc_code"><strong>IFSC Code</strong><span class="required-asterisk">*</span></label>
                <input id="ifsc_code" type="text" pInputText formControlName="ifsc_code"
                  (keydown)="validateIFSCCode($event)" />
              </div>
              <div class="field col">
                <label><strong></strong></label>
                <button type="button" pButton icon="pi pi-search" style="margin-top: 10%;"
                  (click)="searchIFSCCode(bank.get('ifsc_code')?.value,i)"></button>
              </div>
              <div class="field col">
                <label for="bank_name"><strong>Bank Name</strong><span class="required-asterisk">*</span></label>
                <input id="bank_name" type="text" pInputText formControlName="bank_name" />
              </div>
              <div class="field col">
              </div>
            </div>
            <div class="p-formgrid grid">
              <div class="field col feild-bg">
                <label for="bank_address"><strong>Bank Address</strong><span class="required-asterisk">*</span></label>
                <input id="bank_address" type="text" pInputText formControlName="bank_address" />
              </div>
              <div class="field col feild-bg">
                <label for="branch_name"><strong>Branch Name</strong><span class="required-asterisk">*</span></label>
                <input id="branch_name" type="text" pInputText formControlName="branch_name" />
              </div>
            </div>
            <div class="p-formgrid grid">
              <div class="field col">
                <label for="bank_region"><strong>Bank Region</strong><span class="required-asterisk">*</span></label>
                <p-dropdown formControlName="bank_region" [options]="state" optionLabel="label" optionValue="value"
                  placeholder="Select a Bank Region" />
              </div>
              <div class="field col">
                <label for="bank_city"><strong>Bank City</strong><span class="required-asterisk">*</span></label>
                <input id="bank_city" type="text" pInputText formControlName="bank_city" />
              </div>
            </div>
            <div class="p-formgrid grid">
              <div class="field col feild-bg" style="width: fit-content">
                <label htmlFor="Cancel-cheq">
                  <strong>Upload Bank Document</strong>
                </label>
                <div class="p-formgrid grid">
                  <div class="field col">
                    <p-fileUpload mode="basic" name="CancelledChequeFile[]" accept="image/*,.pdf,.xls,.xlsx"
                      [maxFileSize]="25000000" (onSelect)="onUploadFileForCancelledCheque($event, 'cancelled_cheque',i)"
                      chooseLabel="Upload File"
                      pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                      tooltipPosition="right" *ngIf="isUploadFile">
                    </p-fileUpload>
                    <div *ngIf="!isUploadFile">
                      <span>{{ bank.get('cancelled_cheque')?.value }}</span>
                      <button type="button" pButton icon="pi pi-check"
                        class="p-fileupload-close p-button-rounded p-button-success"
                        (click)="cancelUploadForCancelledCheque(i)"></button>
                    </div>
                  </div>
                  <div class="field col">
                    <button pButton class="btn btn-primary" style="max-width: min-content" *ngIf="patchBankUploaded[i]?.cancelled_cheque"
                    (click)="downloadFileForBanks(i, 'cancelled_cheque_' + i)">
                      <i class="pi pi-download"></i>
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <div class="p-formgrid grid">
              <div class="field col mt-5">
                <button pButton type="button" label="Add More" class="p-button-md p-button-primary"
                  (click)="addMultipleBankDetail()"></button>
              </div>
              <div class="field col mt-4" *ngIf="i !== 0">
                <button pButton type="button" icon="fas fa-xmark" label="Delete" class="p-button-md p-button-danger mt-2"
                  (click)="removeBankDetail(i)" *ngIf="i > 0"></button>
              </div>

            </div>
          </div>
          </div>
        </form> -->
      <header class="orange-center">
        <p><strong>LEGAL DETAILS</strong></p>
      </header>

      <div class="p-formgrid grid mt-5">
        <div class="field col bg-feild">
          <label for="pan_no"><strong>PAN No</strong><span class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
          <input id="pan_no" type="text" [readonly]="ispan" class="highlight" pInputText formControlName="pan_no" (blur)="onPanBlur($event)" (keydown)="onPanNoInput($event)"
             [class.error]="
              panNumber &&
              panNumber.invalid &&
              (panNumber.dirty || panNumber.touched)
            " />
          <div *ngIf="
              panNumber &&
              panNumber.invalid &&
              (panNumber.dirty || panNumber.touched)
            ">
            <div *ngIf="panNumber.errors && panNumber.errors['required']" style="color: red">
              PAN Number is required
            </div>
            <div *ngIf="panNumber.errors && panNumber.errors['invalidPan']" style="color: red">
              Invalid PAN Number
            </div>
          </div>
        </div>
        <div class="field col">
          <div class="p-formgrid grid">
            <div class="field col bg-feild">
              <label htmlFor="Other">
                <strong>Pan No document</strong>
              </label>
              <p-fileUpload mode="basic" name="otherDocuments[]" accept="image/*,.pdf,.xls,.xlsx" [maxFileSize]="25000000"
                (onSelect)="onUploadFile($event, 'pan_document')" chooseLabel="Upload File" *ngIf="!panDocument"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" >
              </p-fileUpload>
              <div *ngIf="panDocument">
                <span>{{ panDocument.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelUpload('pan_document')"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content; margin-top: 30px;"
                *ngIf="pan_documentUrl" (click)="downloadFile(pan_documentUrl, 'pan_document')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isIndustry" class="p-formgrid grid">
        <div class="field col feild-bg">
          <label for="msme_no"><strong>MSME No</strong><span class="required-asterisk">*</span></label>
          <input id="msme_no" type="text" pInputText formControlName="msme_no" (blur)="OnBlurMsme($event)" />
        </div>
        <div class="field col feild-bg">
          <label for="msme_no"><strong>Expiry year</strong><span class="required-asterisk">*</span></label>
          <p-dropdown [options]="msmeYearList" formControlName="msme_expiry_year" optionLabel="year" optionValue="year" placeholder="Select Expiry year"
            (onChange)="onMsmeExpiryYearChange($event.value)" />
          <div *ngIf="enableMSMEYearInvalidMessage" style="color: red">
            Your MSME Certificate is expired please renew before on boarding
          </div>
        </div>
        <div class="field col feild-bg">
          <div class="p-formgrid grid">
            <div class="field col">
              <label for="msme_no"><strong>MSME Certificate</strong></label>
              <p-fileUpload mode="basic" name="msmeCertificate[]" accept="image/*,.pdf,.xls,.xlsx"
                [maxFileSize]="25000000"
                pTooltip=".pdf, .jpg, .png, .jpeg .docs .xlsx Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" (onSelect)="onUploadFile($event, 'msme_certificate')" chooseLabel="Upload File"
                *ngIf="!msmeCertificateFile" [disabled]="enableMSMEUploadButton">
              </p-fileUpload>
              <div *ngIf="msmeCertificateFile">
                <span>{{ msmeCertificateFile.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelUpload('msme_certificate')"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content; margin-top: 30px;"
                *ngIf="msme_certificateUrl" (click)="downloadFile(msme_certificateUrl, 'msme_certificate')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col">
          <label for="cin_no"><strong>CIN No</strong><span class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
          <input id="cin_no" type="text" pInputText formControlName="cin_no" (blur)="OnBlurCIN($event)"/>
        </div>
        <div class="field col">
          <div class="p-formgrid grid">
            <div class="field col">
              <label htmlFor="CIN">
                <strong>CIN</strong>
              </label>
              <p-fileUpload mode="basic" name="upload_cin[]" accept="image/*,.pdf,.xls,.xlsx" [maxFileSize]="25000000"
                (onSelect)="onUploadFile($event, 'upload_cin')" chooseLabel="Upload File" *ngIf="!uploadCIN"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right">
              </p-fileUpload>
              <div *ngIf="uploadCIN">
                <span>{{ uploadCIN.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelUpload('upload_cin')"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content; margin-top: 30px;"
                *ngIf="upload_cinUrl" (click)="downloadFile(upload_cinUrl, 'upload_cin')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg">
          <label for="legal_name"><strong>Legal Name</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="legal_name" type="text" pInputText formControlName="legal_name" />
        </div>
        <div class="field col feild-bg">
          <label for="tin_no"><strong>TIN No</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="tin_no" type="text" pInputText formControlName="tin_no" />
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col">
          <label for="aadhar_no"><strong>Aadhar No</strong></label>
          <input id="aadhar_no" type="number" (keydown)="validateAadharNumber($event)" pInputText
            formControlName="aadhar_no" />
          <div *ngIf="registrationForm.get('aadhar_no')?.errors" style="color: red">
            Aadhar number must be exactly 12 digits long.
          </div>
        </div>
        <div class="field col">
          <label for="din_no"><strong>DIN No</strong>&nbsp;&nbsp;&nbsp;</label>
          <input id="din_no" type="text" pInputText formControlName="din_no" />
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="field col feild-bg" style="width: fit-content">
          <label htmlFor="Self Declaration By Vendor">
            <strong>Self Declaration By Vendor</strong>
          </label>
          <div class="p-formgrid grid">
            <div class="field col" >
              <button pButton class="btn btn-primary" style="max-width: fit-content;"
                (click)="selfDeclarationByVendorFormDownload()">
                <i class="pi pi-download"></i>&nbsp;Form
              </button>
            </div>
            <div class="field col">
              <p-fileUpload mode="basic" name="selfDeclarationByVendor" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000" (onSelect)="selfDeclarationByVendorUpload($event)" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" *ngIf="!selfDeclarationByVendor">
              </p-fileUpload>
              <div *ngIf="selfDeclarationByVendor">
                <span>{{ selfDeclarationByVendor.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelSelfDeclarationByVendorUpload()"></button>
              </div>
            </div>

            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content" *ngIf="self_declaration_by_vendorUrl"
                (click)="
                  downloadFile(
                    self_declaration_by_vendorUrl,
                    'self_declaration_by_vendor'
                  )
                ">
                <i class="pi pi-download"></i>
              </button>
            </div>

          </div>
        </div>
        <!-- </div> -->
        <div class="field col feild-bg" style="width: fit-content">
          <label htmlFor="company-registration">
            <strong>Company Registration</strong>
          </label>
          <div class="p-formgrid grid">
            <div class="field col">
              <p-fileUpload mode="basic" name="demo[]" accept="image/*,.pdf,.xls,.xlsx" [maxFileSize]="25000000"
                (onSelect)="onUploadFile($event, 'company_registration')" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg .docs .xlsx Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" *ngIf="!companyRegistrationFile">
              </p-fileUpload>
              <div *ngIf="companyRegistrationFile">
                <span>{{ companyRegistrationFile.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelUpload('company_registration')"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content" *ngIf="company_registrationUrl"
                (click)="
                  downloadFile(company_registrationUrl, 'company_registration')
                ">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="field col">
          <label htmlFor="Other">
            <strong>Other</strong>
          </label>
          <p-fileUpload mode="basic" name="otherDocuments[]" accept="image/*,.pdf,.xls,.xlsx" [maxFileSize]="25000000"
            (onSelect)="onUploadFile($event, 'other_documents')" chooseLabel="Upload File" *ngIf="!otherDocumentsFiles"
            pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
            tooltipPosition="right">
          </p-fileUpload>
          <div *ngIf="otherDocumentsFiles">
            <span>{{ otherDocumentsFiles.name }}</span>
            <button type="button" pButton icon="pi pi-check" class="p-fileupload-close p-button-rounded p-button-success"
              (click)="cancelUpload('other_documents')"></button>
          </div>
        </div>
        <div class="field col">
          <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:30px"
            *ngIf="other_documentsUrl" (click)="downloadFile(other_documentsUrl, 'other_documents')">
            <i class="pi pi-download"></i>
          </button>
        </div>
        <div class="field col"></div>
        <div class="field col"></div>
      </div>
      <!-- </div> -->
      <!-- </div> -->

      <header class="orange-center">
        <p><strong>DOCUMENTS REQUIRED IN EVALUATION SHEET</strong></p>
      </header>
      <div class="p-formgrid grid mt-3">
        <div class="field col">
          <label ><strong>Evaluation Sheet</strong></label>

          <div class="p-formgrid grid">
            <div class="field col" >
              <button pButton class="btn btn-primary" style="max-width: fit-content;"
                (click)="evaluationSheetFormatDownload2L()">
                <i class="pi pi-download"></i>&nbsp;Spend less than 5 lakhs
              </button>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: fit-content;"
                (click)="evaluationSheetFormatDownload5L()">
                <i class="pi pi-download"></i>&nbsp;Spend More than 5 Lakh
              </button>
            </div>
            <div class="field col" >
              <p-fileUpload mode="basic" name="evaluationSheet[]" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000" (onSelect)="evaluationSheetUpload($event)" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" *ngIf="!evaluationSheet"></p-fileUpload>
              <div *ngIf="evaluationSheet">
                <span>{{ evaluationSheet.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success"
                  (click)="cancelEvaluationSheetUpload()"></button>
              </div>
            </div>

            <div class="field col" *ngIf="evaluationSheetUrl">
              <button pButton class="btn btn-primary" *ngIf="evaluationSheetUrl" style="max-width: min-content"
                (click)="downloadFile(evaluationSheetUrl, 'evaluation_sheet')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="field col" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col">
              <label for="din_no"><strong>Company Profile</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_1_name" (blur)="OnBlurDocument1($event)"/>
            </div>
            <div class="field col">
              <p-fileUpload mode="basic" name="Document 1[]" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" [style]="{'margin-top': '30px'}" (onSelect)="document1Upload($event)" chooseLabel="Upload File" *ngIf="!document1">
              </p-fileUpload>
              <div *ngIf="document1">
                <span>{{ document1.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success" (click)="cancelDocument1Upload()"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:25px" *ngIf="document1Url"
                (click)="downloadFile(document1Url, 'document_1')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid mt-3">
        <div class="field col feild-bg">

          <div class="p-formgrid grid">
            <div class="field col">
              <label for="din_no"><strong>Balance Sheet</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_2_name" (blur)="OnBlurDocument2($event)"/>
            </div>
            <div class="field col" style="width: fit-content">
              <p-fileUpload mode="basic" name="Document 2[]" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000" (onSelect)="document2Upload($event)" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" [style]="{'margin-top': '30px'}" *ngIf="!document2">
              </p-fileUpload>
              <div *ngIf="document2">
                <span>{{ document2.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success" (click)="cancelDocument2Upload()"></button>
              </div>
            </div>
            <!-- <div class="field col">

          </div> -->

            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:25px" *ngIf="document2Url"
                (click)="downloadFile(document2Url, 'document_2')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="field col feild-bg" style="width: fit-content">

          <div class="p-formgrid grid">
            <div class="field col">
              <label for="din_no"><strong>Auditor Report</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_3_name" />
            </div>
            <div class="field col">
              <p-fileUpload mode="basic" name="Document 3[]" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000" (onSelect)="document3Upload($event)" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" [style]="{'margin-top': '30px'}" *ngIf="!document3">
              </p-fileUpload>
              <div *ngIf="document3">
                <span>{{ document3.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success" (click)="cancelDocument3Upload()"></button>
              </div>
            </div>
            <div class="field col feild-bg">
              <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:25px" *ngIf="document3Url"
                (click)="downloadFile(document3Url, 'document_3')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="field col" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col">
              <label for="din_no"><strong>ISO Certificate</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_4_name" />
            </div>
            <div class="field col">
              <p-fileUpload mode="basic" name="otherDocuments[]" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000" (onSelect)="document4Upload($event)" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" [style]="{'margin-top': '30px'}" *ngIf="!document4">
              </p-fileUpload>
              <div *ngIf="document4">
                <span>{{ document4.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success" (click)="cancelDocument4Upload()"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:25px" *ngIf="document4Url"
                (click)="downloadFile(document4Url, 'document_4')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="field col" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col">
              <label for="din_no"><strong>List Of Equipment</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_5_name" />
            </div>
            <div class="field col">
              <!-- <label htmlFor="email2">
                <strong>Document-5</strong>
              </label> -->
              <p-fileUpload mode="basic" name="Document 5[]" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000" (onSelect)="document5Upload($event)" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" [style]="{'margin-top': '30px'}" *ngIf="!document5">
              </p-fileUpload>
              <div *ngIf="document5">
                <span>{{ document5.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success" (click)="cancelDocument5Upload()"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:25px" *ngIf="document5Url"
                (click)="downloadFile(document5Url, 'document_5')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid grid">
        <div class="field col feild-bg" style="width: fit-content">
          <div class="p-formgrid grid">
            <div class="field col">
              <label for="din_no"><strong>Other</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="din_no" type="text" pInputText formControlName="document_6_name" />
            </div>
            <div class="field col">
              <p-fileUpload mode="basic" name="Document 6[]" accept="image/*,application/pdf,.docx,.xlsx"
                [maxFileSize]="25000000" (onSelect)="document6Upload($event)" chooseLabel="Upload File"
                pTooltip=".pdf, .jpg, .png, .jpeg, .xlsx, .docs Extenstion Accepted (Max file size 25MB)"
                tooltipPosition="right" [style]="{'margin-top': '30px'}" *ngIf="!document6">
              </p-fileUpload>
              <div *ngIf="document6">
                <span>{{ document6.name }}</span>
                <button type="button" pButton icon="pi pi-check"
                  class="p-fileupload-close p-button-rounded p-button-success" (click)="cancelDocument6Upload()"></button>
              </div>
            </div>
            <div class="field col">
              <button pButton class="btn btn-primary" style="max-width: min-content;margin-top:25px" *ngIf="document6Url"
                (click)="downloadFile(document6Url, 'document_6')">
                <i class="pi pi-download"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="field col"></div>
      </div>
      <header class="orange-center mb-5" *ngIf="false">
        <p><strong>CONTACT DETAILS</strong></p>
      </header>
      <div formGroupName="primary_address">
        <div formGroupName="contact_person">
          <div class="p-formgrid grid" *ngIf="false">
            <div class="field col">
              <label for="name1"><strong>Name</strong><span class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
              <input id="name1" type="text" pInputText formControlName="name1" />
            </div>
            <div class="field col">
              <label for="phone_no"><strong>Phone No</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="phone_no" type="text" (keydown)="validateNumber($event)" pInputText formControlName="phone_no" />
            </div>
          </div>
          <div class="p-formgrid grid" *ngIf="false">
            <div class="field col">
              <label for="mobile_no"><strong>Mobile No</strong><span class="required-asterisk">*</span></label>
              <p-dropdown [options]="countries" formControlName="mobile_no" placeholder="Select a country"
                [editable]="true" (onChange)="updateMobileNoCode($event)" />
            </div>
            <div class="field col">
              <label for="e_mail_id"><strong>E Mail ID</strong><span
                  class="required-asterisk">*</span>&nbsp;&nbsp;&nbsp;</label>
              <input id="e_mail_id" type="email" pInputText formControlName="e_mail_id" />
            </div>
          </div>
          <div class="p-formgrid grid" *ngIf="false">
            <div class="field col">
              <label for="website_url"><strong>Website/ URL</strong>&nbsp;&nbsp;&nbsp;</label>
              <input id="website_url" type="text" pInputText formControlName="website_url" />
            </div>
            <div class="field col">
              <label for="website_url"><strong>Alternate Email Id </strong></label>
              <input id="website_url" type="text" pInputText formControlName="alternate_email_id" />
              <div *ngIf="registrationForm.hasError('emailMatch2')">
                <p style="color: red">
                  Please make sure the Email id are unique.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="orange-center mb-5">
        <p><strong>CONTACT DETAILS</strong></p>
      </header>
      <form [formGroup]="contactForm">
        <div class="card p-fluid feild-bg mb-5" formArrayName="contacts">
          <div class="p-formgrid grid">
            <div class="field col"></div>
            <div class="field col"></div>
            <div class="field col"></div>
            <div class="field col"></div>
            <!-- <div class="field col">
              <button pButton type="button" label="Add Contact" class="p-button-sm p-button-primary"
                (click)="addContact()"></button>
            </div> -->
          </div>
          <div *ngFor="let contact of contacts.controls; let i = index">
            <div class="p-formgrid grid" [formGroupName]="i">
              <!-- <div class="field col">
                <label for="telephone"><strong>Name</strong><span *ngIf="i === 0 || 1"
                    class="required-asterisk">*</span></label>
                <input type="tel" id="vm_name" formControlName="vm_name" class="p-inputtext" required />
              </div> -->
              <div class="field col mt-2">
                <label for="telephone"><strong>Telephone</strong></label>
                <input type="tel" id="telephone" formControlName="telephone" class="p-inputtext"
                  (input)="searchContactDetail($event, i, 'telephone')" (keydown)="validateForTelephoneAndMobile($event)" />
                <div *ngIf="telephoneErrors[i]">
                  <p style="color: red">Telephone number exists.</p>
                </div>
              </div>
              <div class="field col">
                <label for="email"><strong>Email ID</strong><span *ngIf="i === 0"
                    class="required-asterisk">*</span></label>
                <input type="email" id="email" formControlName="email_id" class="p-inputtext"
                  (input)="searchContactDetail($event, i, 'email_id')" />
                <div *ngIf="contact.get('email_id')?.invalid">
                  <p *ngIf="contact.get('email_id')?.errors?.['pattern']" style="color: red">Please enter a valid email
                    address.</p>
                </div>
                <div *ngIf="emailErrors[i]">
                  <p style="color: red">Email address exists.</p>
                </div>
              </div>
              <div class="field col">
                <label for="mobile"><strong>Mobile Number</strong><span *ngIf="i === 0"
                    class="required-asterisk">*</span></label>
                <input type="tel" id="mobile" formControlName="mobile_phone" class="p-inputtext"
                  (input)="searchContactDetail($event, i, 'mobile_phone')" (keydown)="validateForTelephoneAndMobile($event)" />
                <div *ngIf="mobileErrors[i]">
                  <p style="color: red">Mobile number exists.</p>
                </div>
              </div>
              <div class="field col mt-5" *ngIf="i === 0">
                <button pButton type="button" label="Add More" class="p-button-sm p-button-primary"
                  (click)="addContact()"></button>
              </div>
              <div class="field col mt-5" *ngIf="i !== 0">
                <button pButton type="button" class="p-button-sm p-button-danger" (click)="removeContact(i)" *ngIf="i > 0"
                  icon="fas fa-xmark"></button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <header class="orange-center mb-5">
        <p><strong>CONTACT PERSON</strong></p>
      </header>
      <form [formGroup]="rockmancontactForm">
        <div class="card p-fluid" formArrayName="rockmancontacts">
          <div class="p-formgrid grid">
            <div class="field col"></div>
            <div class="field col"></div>
            <div class="field col"></div>
          </div>
          <div *ngFor="let rockamncontact of rockmancontacts.controls; let i = index">
            <div class="p-formgrid grid" [formGroupName]="i">
              <div class="field col">
                <label for="telephone"><strong>First Name</strong><span *ngIf="i === 0"
                    class="required-asterisk">*</span></label>
                <input type="tel" id="first_name" formControlName="first_name" class="p-inputtext" />
              </div>
              <div class="field col">
                <label for="telephone"><strong>Last Name</strong><span *ngIf="i === 0"
                    class="required-asterisk">*</span></label>
                <input type="tel" id="last_name" formControlName="last_name" class="p-inputtext" />
              </div>
              <div class="field col">
                <label for="Rockman_contact_department"><strong>Department</strong><span *ngIf="i === 0"
                    class="required-asterisk">*</span></label>
                <p-dropdown [options]="Rockman_contact_department" id="Rockman_contact_department"
                  formControlName="rockman_contact_department" placeholder="Select Department"></p-dropdown>
              </div>
              <div class="field col">
                <label for="Rockman_contact_function"><strong>Function</strong><span *ngIf="i === 0"
                    class="required-asterisk">*</span></label>
                <p-dropdown [options]="Rockman_contact_function" id="Rockman_contact_function"
                  formControlName="rockman_contact_function" placeholder="Select Function"></p-dropdown>
              </div>
              <div class="field col mt-5" *ngIf="i === 0">
                <button pButton type="button" label="Add More" class="p-button-sm p-button-primary"
                  (click)="addRockmanContact()"></button>
              </div>
              <div class="field col mt-4" *ngIf="i !== 0">
                <button pButton type="button" icon="fas fa-xmark" class="p-button-sm p-button-danger mt-2"
                  (click)="removeRockmanContact(i)" *ngIf="i > 0"></button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- <div style="display: flex; justify-content: center" class="mt-5">
        <div>
          <p-checkbox formControlName="note" [binary]="true" inputId="binary" />
        </div>
        <div>
          <a href="https://rocknet.rockman.in/Vendor2_New/Supplier_code_of_conduct_for_Sustainable_Procurement_Rockman.pdf"
            class="ml-5" target="_blank"><strong style="color: red">I have read and accepted (Click here to read SUPPLIER
              CODE OF
              CONDUCT FOR SUSTAINABLITY PROCUREMENT & SELF DECLARATION)</strong></a>
        </div>
      </div> -->
      <div style="margin-top: 20px"></div>
      <div style="display: flex; justify-content: center; align-items: center">
        <!-- <button pButton type="button" style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 70px;
          " label="Save" (click)="submitForm(true)"></button> -->
        <button pButton type="button" style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 70px;
            margin-left: 30;
          " pTooltip="Are You Sure You Want To Submit!" label="Submit" (click)="submitForm()"></button>
      </div>
    </div>

    <p-dialog header="Missing Required Fields" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '50vw' }">
      <div *ngIf="missingFields.length > 0">
        <p>The following fields are required and need to be filled:</p>
        <ul>
          <li *ngFor="let field of missingFields">{{ field }}</li>
        </ul>
      </div>
      <p-footer>
        <button type="button" pButton label="Close" (click)="closeDialog()"></button>
      </p-footer>
    </p-dialog>
    <p-dialog header="Matched IFSC Code List" [(visible)]="ifscDialog" [modal]="true" [style]="{ width: '60%' }">
      <div>
        <p-table [value]="ifscResponse" [(selection)]="selectedIFSC" dataKey="name" [scrollable]="true" scrollHeight="400px" [tableStyle]="{'min-width': '200rem'}">
          <ng-template pTemplate="header">
            <tr>
              <th></th>
              <th>BANK<p-sortIcon field="bank"></p-sortIcon></th>
              <th>IFSC<p-sortIcon field="ifsc"></p-sortIcon></th>
              <th>BRANCH<p-sortIcon field="branch"></p-sortIcon></th>
              <th>ADDRESS<p-sortIcon field="address"></p-sortIcon></th>
              <th>CITY1<p-sortIcon field="city1"></p-sortIcon></th>
              <th>CITY2<p-sortIcon field="city2"></p-sortIcon></th>
              <th>STATE<p-sortIcon field="state"></p-sortIcon></th>
              <th>STD CODE<p-sortIcon field="std_code"></p-sortIcon></th>
              <th>PONE<p-sortIcon field="pone"></p-sortIcon></th>
            </tr>
            <tr>
              <th></th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="bank"
                        placeholder="Search Bank"
                        ariaLabel="Filter Name" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="ifsc"
                        placeholder="Search IFSC"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="branch"
                        placeholder="Search Branch"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="address"
                        placeholder="Search Address"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="city1"
                        placeholder="Search City1"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="city2"
                        placeholder="Search City2"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="state"
                        placeholder="Search State"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="std_code"
                        placeholder="Search STD Code"
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter
                        type="text"
                        field="pone"
                        placeholder="Search Pone"
                        ariaLabel="Filter Country" />
                </th>
              </tr>

          </ng-template>
          <ng-template pTemplate="body" let-ifsc>
            <tr>
              <td>
                <p-tableRadioButton [value]="ifsc" />
              </td>
              <td>{{ifsc.bank}}</td>
              <td>{{ifsc.ifsc}}</td>
              <td>{{ifsc.branch}}</td>
              <td>{{ifsc.address}}</td>
              <td>{{ifsc.city1}}</td>
              <td>{{ifsc.city2}}</td>
              <td>{{ifsc.state}}</td>
              <td>{{ifsc.std_code}}</td>
              <td>{{ifsc.pone}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <p-footer>
        <button type="button" pButton label="Okay" (click)="ifscSelected(selectedIFSC)"></button>
      </p-footer>
    </p-dialog>
  </form>
  <p-toast></p-toast>

  <!-- Loading Screen -->
  <div *ngIf="isLoading" class="loading-overlay">
    <app-loading-screen></app-loading-screen>
  </div>
